import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=5fdd5697&scoped=true"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"
import style0 from "./radarChart.vue?vue&type=style&index=0&id=5fdd5697&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd5697",
  null
  
)

export default component.exports